
















































import { Vue, Component, Watch } from 'vue-property-decorator'
import CatalogHeader from '@/modules/catalog/components/CatalogHeader'
import HomeShopItem from '../../components/HomeShopItem'
import GoogleMapDialog from '../../components/GoogleMapDialog'
import { getModule } from 'vuex-module-decorators'
import ServerError from '@/utils/server_error'
import memberStore from '@/modules/member/member.store'
import venueStore from '@/modules/venue/venue.store'
import { MemberEntity } from '@/api/member'
import { VenueEntity, VenueAPI, ResponseStatus } from '@/api/venue'

@Component({
  components: {
    CatalogHeader,
    HomeShopItem
  }
})
export default class HomeShopOthers extends Vue {
  memberModule = getModule(memberStore, this.$store)
  venueModule = getModule(venueStore, this.$store)
  venues: VenueEntity[] = []
  isLoading: boolean = false

  /* Hooks */
  async created() {
    await this.getVenuesByCompanyID()
  }

  get member(): MemberEntity | null {
    return this.memberModule.member
  }

  get homeShop(): VenueEntity | null {
    return this.member!.homeShop
  }

  get venueCompanyId() {
    if (this.homeShop) return this.homeShop!.venueCompanyId
    else return ''
  }

  /* Methods */
  async getVenuesByCompanyID() {
    if (!this.venueCompanyId) return
    try {
      this.isLoading = true
      const response = await VenueAPI.getVenuesByCompanyID(this.venueCompanyId)
      let payload = response.data.payload
      if (response.data.status === ResponseStatus.Ok && payload) {
        this.venues = payload
      }
      return false
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('Misc.ErrorFetchData'))
        console.error(err)
      }
    } finally {
      this.isLoading = false
    }
  }
}
